import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button } from '../util/buttons';
import ProjectFieldsPopover from './components/ProjectFieldsPopover';
import ProjectTemplateExportsTable from './ProjectTemplateExportsTable';
import projectTemplateExportsService from './project_template_exports.service';
import ClaimCostExportTab from './ClaimCostExportTab';
export default function DataCenterExportTab(_ref) {
  let {
    claimGroup,
    userCanDelete = true,
    showDownloadTemplateButton = true
  } = _ref;
  const [selectedProjectFields, setSelectedProjectFields] = useState(window.MARKET_CONSTANTS.PROJECT_EXPORT_FIELDS_LIST);
  const [loading, setLoading] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    exports,
    createExport,
    deleteExport
  } = projectTemplateExportsService.useCrud(setLoading, claimGroup.id);
  const handleGenerateExport = async () => {
    setLoading(true);
    await createExport(selectedProjectFields);
    setLoading(false);
  };
  const handleDeleteExport = async exportId => {
    setLoading(true);
    await deleteExport(exportId);
    setLoading(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-100"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "projects",
    id: "export-sub-tabs",
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "projects",
    title: t('projects')
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3 mb-4"
  }, /*#__PURE__*/React.createElement(ProjectFieldsPopover, {
    selectedProjectFields: selectedProjectFields,
    setSelectedProjectFields: setSelectedProjectFields
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: handleGenerateExport,
    size: "md",
    variant: "info",
    iconPosition: "left",
    icon: "download",
    style: {
      width: '240px'
    },
    disabled: loading
  }, loading ? t('generating') : t('export_data'))), /*#__PURE__*/React.createElement("hr", {
    className: "my-4"
  }), /*#__PURE__*/React.createElement("h6", {
    className: "text-primary mb-3"
  }, t('export_history')), /*#__PURE__*/React.createElement(ProjectTemplateExportsTable, {
    exports: exports,
    loading: loading,
    onDelete: handleDeleteExport,
    userCanDelete: userCanDelete
  }))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "costs",
    title: t('costs')
  }, /*#__PURE__*/React.createElement(ClaimCostExportTab, {
    claimGroup: claimGroup,
    userCanDelete: userCanDelete,
    showDownloadTemplateButton: showDownloadTemplateButton
  }))));
}